/**
 * Generated by @openapi-codegen
 *
 * @version 0.0.1
 */
import * as reactQuery from '@tanstack/react-query';
import {
  useTerminationApiContext,
  TerminationApiContext,
} from './terminationApiContext';
import type * as Fetcher from './terminationApiFetcher';
import { terminationApiFetch } from './terminationApiFetcher';
import type * as Schemas from './terminationApiSchemas';

export type PostTerminationSimulationPathParams = {
  /**
   * The id of the organization to retrieve
   *
   * @format uuid
   */
  organizationId: string;
};

export type PostTerminationSimulationError = Fetcher.ErrorWrapper<undefined>;

export type PostTerminationSimulationVariables = {
  body: Schemas.SimulationInput;
  pathParams: PostTerminationSimulationPathParams;
} & TerminationApiContext['fetcherOptions'];

export const fetchPostTerminationSimulation = (
  variables: PostTerminationSimulationVariables,
  signal?: AbortSignal,
) =>
  terminationApiFetch<
    Schemas.SimulationEntry,
    PostTerminationSimulationError,
    Schemas.SimulationInput,
    {},
    {},
    PostTerminationSimulationPathParams
  >({
    url: '/api/termination/organizations/{organizationId}/simulations',
    method: 'post',
    ...variables,
    signal,
  });

export const usePostTerminationSimulation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SimulationEntry,
      PostTerminationSimulationError,
      PostTerminationSimulationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useTerminationApiContext();
  return reactQuery.useMutation<
    Schemas.SimulationEntry,
    PostTerminationSimulationError,
    PostTerminationSimulationVariables
  >({
    mutationFn: (variables: PostTerminationSimulationVariables) =>
      fetchPostTerminationSimulation({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SearchTerminationSimulationsPathParams = {
  /**
   * The id of the organization to retrieve
   *
   * @format uuid
   */
  organizationId: string;
};

export type SearchTerminationSimulationsError = Fetcher.ErrorWrapper<undefined>;

export type SearchTerminationSimulationsVariables = {
  body?: Schemas.SearchInput;
  pathParams: SearchTerminationSimulationsPathParams;
} & TerminationApiContext['fetcherOptions'];

export const fetchSearchTerminationSimulations = (
  variables: SearchTerminationSimulationsVariables,
  signal?: AbortSignal,
) =>
  terminationApiFetch<
    Schemas.SimulationList,
    SearchTerminationSimulationsError,
    Schemas.SearchInput,
    {},
    {},
    SearchTerminationSimulationsPathParams
  >({
    url: '/api/termination/organizations/{organizationId}/simulations/search',
    method: 'post',
    ...variables,
    signal,
  });

export const useSearchTerminationSimulations = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SimulationList,
      SearchTerminationSimulationsError,
      SearchTerminationSimulationsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useTerminationApiContext();
  return reactQuery.useMutation<
    Schemas.SimulationList,
    SearchTerminationSimulationsError,
    SearchTerminationSimulationsVariables
  >({
    mutationFn: (variables: SearchTerminationSimulationsVariables) =>
      fetchSearchTerminationSimulations({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetTerminationSimulationPathParams = {
  /**
   * The id of the organization to retrieve
   *
   * @format uuid
   */
  organizationId: string;
  /**
   * The ID of the simulation
   *
   * @format uuid
   */
  simulationId: string;
};

export type GetTerminationSimulationError = Fetcher.ErrorWrapper<undefined>;

export type GetTerminationSimulationVariables = {
  pathParams: GetTerminationSimulationPathParams;
} & TerminationApiContext['fetcherOptions'];

export const fetchGetTerminationSimulation = (
  variables: GetTerminationSimulationVariables,
  signal?: AbortSignal,
) =>
  terminationApiFetch<
    Schemas.SimulationEntry,
    GetTerminationSimulationError,
    undefined,
    {},
    {},
    GetTerminationSimulationPathParams
  >({
    url: '/api/termination/organizations/{organizationId}/simulations/{simulationId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetTerminationSimulation = <TData = Schemas.SimulationEntry,>(
  variables: GetTerminationSimulationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SimulationEntry,
      GetTerminationSimulationError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useTerminationApiContext(options);
  return reactQuery.useQuery<
    Schemas.SimulationEntry,
    GetTerminationSimulationError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/termination/organizations/{organizationId}/simulations/{simulationId}',
      operationId: 'getTerminationSimulation',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTerminationSimulation(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type SearchTerminationSimulationDataPathParams = {
  /**
   * The id of the organization to retrieve
   *
   * @format uuid
   */
  organizationId: string;
  /**
   * The ID of the simulation
   *
   * @format uuid
   */
  simulationId: string;
};

export type SearchTerminationSimulationDataError =
  Fetcher.ErrorWrapper<undefined>;

export type SearchTerminationSimulationDataVariables = {
  body?: Schemas.SearchInput;
  pathParams: SearchTerminationSimulationDataPathParams;
} & TerminationApiContext['fetcherOptions'];

export const fetchSearchTerminationSimulationData = (
  variables: SearchTerminationSimulationDataVariables,
  signal?: AbortSignal,
) =>
  terminationApiFetch<
    Schemas.SimulationDataList,
    SearchTerminationSimulationDataError,
    Schemas.SearchInput,
    {},
    {},
    SearchTerminationSimulationDataPathParams
  >({
    url: '/api/termination/organizations/{organizationId}/simulations/{simulationId}/data/search',
    method: 'post',
    ...variables,
    signal,
  });

export const useSearchTerminationSimulationData = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SimulationDataList,
      SearchTerminationSimulationDataError,
      SearchTerminationSimulationDataVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useTerminationApiContext();
  return reactQuery.useMutation<
    Schemas.SimulationDataList,
    SearchTerminationSimulationDataError,
    SearchTerminationSimulationDataVariables
  >({
    mutationFn: (variables: SearchTerminationSimulationDataVariables) =>
      fetchSearchTerminationSimulationData({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetTerminationSimulationDataPathParams = {
  /**
   * The id of the organization to retrieve
   *
   * @format uuid
   */
  organizationId: string;
  /**
   * The ID of the simulation
   *
   * @format uuid
   */
  simulationId: string;
  /**
   * The id of the contract to retrieve
   *
   * @format uuid
   */
  contractId: string;
};

export type GetTerminationSimulationDataError = Fetcher.ErrorWrapper<undefined>;

export type GetTerminationSimulationDataVariables = {
  pathParams: GetTerminationSimulationDataPathParams;
} & TerminationApiContext['fetcherOptions'];

export const fetchGetTerminationSimulationData = (
  variables: GetTerminationSimulationDataVariables,
  signal?: AbortSignal,
) =>
  terminationApiFetch<
    Schemas.SimulationDataEntry,
    GetTerminationSimulationDataError,
    undefined,
    {},
    {},
    GetTerminationSimulationDataPathParams
  >({
    url: '/api/termination/organizations/{organizationId}/simulations/{simulationId}/data/{contractId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetTerminationSimulationData = <
  TData = Schemas.SimulationDataEntry,
>(
  variables: GetTerminationSimulationDataVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SimulationDataEntry,
      GetTerminationSimulationDataError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useTerminationApiContext(options);
  return reactQuery.useQuery<
    Schemas.SimulationDataEntry,
    GetTerminationSimulationDataError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/termination/organizations/{organizationId}/simulations/{simulationId}/data/{contractId}',
      operationId: 'getTerminationSimulationData',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchGetTerminationSimulationData(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: '/api/termination/organizations/{organizationId}/simulations/{simulationId}';
      operationId: 'getTerminationSimulation';
      variables: GetTerminationSimulationVariables;
    }
  | {
      path: '/api/termination/organizations/{organizationId}/simulations/{simulationId}/data/{contractId}';
      operationId: 'getTerminationSimulationData';
      variables: GetTerminationSimulationDataVariables;
    };
